(function () {
  'use strict';

  /* ─────────────────────────────────────────
     1. BADGE UPDATER — querySelectorAll
     ───────────────────────────────────────── */
  function updateBadgeFromCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        console.log('[mm-cart] item_count:', count);

        var allBadges = document.querySelectorAll('.mm-nav-cart-badge');
        var allIcons  = document.querySelectorAll('.mm-nav-icon--cart');

        if (count > 0) {
          allBadges.forEach(function (b) { b.textContent = count; });
          allIcons.forEach(function (icon) {
            if (!icon.querySelector('.mm-nav-cart-badge')) {
              var badge = document.createElement('span');
              badge.className = 'mm-nav-cart-badge';
              badge.textContent = count;
              icon.appendChild(badge);
            }
          });
        } else {
          allBadges.forEach(function (b) { b.remove(); });
        }
      })
      .catch(function (err) {
        console.log('[mm-cart] fetch error:', err);
      });
  }

  /* ─────────────────────────────────────────
     2. DOUBLE-FIRE SCHEDULER
     ───────────────────────────────────────── */
  var fetchTimer  = null;
  var confirmTimer = null;

  function scheduleFetch() {
    clearTimeout(fetchTimer);
    fetchTimer = setTimeout(updateBadgeFromCart, 500);
    clearTimeout(confirmTimer);
    confirmTimer = setTimeout(updateBadgeFromCart, 1200);
  }

  /* ─────────────────────────────────────────
     3. CART ICON → DRAWER TRIGGER
     ───────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cart-drawer-trigger]');
    if (!trigger) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    e.preventDefault();
    drawer.open();
  });

  /* ─────────────────────────────────────────
     4. DOM EVENT LISTENERS
     ───────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    if (e.target.closest('cart-drawer quantity-input button')) { scheduleFetch(); return; }
    if (e.target.closest('cart-remove-button'))                { scheduleFetch(); return; }
    if (e.target.closest('button[name="add"]'))                { scheduleFetch(); return; }
    if (e.target.closest('[data-type="add-to-cart-form"] [type="submit"]')) { scheduleFetch(); return; }
  });

  /* ─────────────────────────────────────────
     5. FORM SUBMIT FALLBACK (badge only)
     ───────────────────────────────────────── */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.classList.contains('mm-atc__form')) return;
    if (form.getAttribute('action') === '/cart/add') { scheduleFetch(); }
  });

  /* ─────────────────────────────────────────
     7. PRODUCT CARD AJAX ADD-TO-CART
     ───────────────────────────────────────── */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList.contains('mm-atc__form')) return;
    e.preventDefault();

    var btn      = form.querySelector('button[name="add"]');
    var idInput  = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');

    if (!idInput || !idInput.value) return;

    var variantId = Number(idInput.value);
    var quantity  = Number(qtyInput ? qtyInput.value : 1) || 1;

    if (btn) { btn.classList.add('mm-atc--loading'); btn.disabled = true; }

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
    .then(function (r) {
      if (!r.ok) {
        if (r.status === 422) {
          return r.json().then(function (errData) {
            var e = new Error('[mm-cart] inventory limit');
            e.inventoryError = true; e.errData = errData; throw e;
          });
        }
        throw new Error('[mm-cart] /cart/add.js status ' + r.status);
      }
      return r.json();
    })
    .then(function () {
      if (btn) { btn.classList.remove('mm-atc--loading'); btn.disabled = false; }
      var prevWarning = form.querySelector('.mm-atc__inventory-warning');
      if (prevWarning) prevWarning.setAttribute('hidden', '');
      updateBadgeFromCart();
      mmRefreshAndOpenDrawer(btn);
    })
    .catch(function (err) {
      if (btn) { btn.classList.remove('mm-atc--loading'); btn.disabled = false; }
      if (err && err.inventoryError) {
        var msg = (err.errData && err.errData.description)
               || (err.errData && err.errData.message)
               || (window.cartStrings && window.cartStrings.error) || '';
        var warning = form.querySelector('.mm-atc__inventory-warning');
        if (warning && msg) {
          var textEl = warning.querySelector('.cart-item__error-text');
          if (textEl) textEl.textContent = msg;
          if (warning._hideTimer) clearTimeout(warning._hideTimer);
          warning.removeAttribute('hidden');
          warning._hideTimer = setTimeout(function () {
            warning.setAttribute('hidden', ''); warning._hideTimer = null;
          }, 5000);
        }
        updateBadgeFromCart();
      } else {
        console.error('[mm-cart] AJAX add-to-cart error:', err);
      }
    });
  });

  /* ─────────────────────────────────────────
     HELPER: mmApplyDrawerHTML
     ───────────────────────────────────────── */
  function mmApplyDrawerHTML(drawer, fresh) {
    var freshItems    = fresh.querySelector('#CartDrawer-CartItems');
    var existingItems = drawer.querySelector('#CartDrawer-CartItems');
    if (freshItems && existingItems) { existingItems.innerHTML = freshItems.innerHTML; }

    var freshFooter    = fresh.querySelector('.drawer__footer');
    var existingFooter = drawer.querySelector('.drawer__footer');
    if (freshFooter && existingFooter) { existingFooter.innerHTML = freshFooter.innerHTML; }

    var freshEmpty    = fresh.querySelector('.drawer__inner-empty');
    var existingEmpty = drawer.querySelector('.drawer__inner-empty');
    if (!freshEmpty && existingEmpty) {
      existingEmpty.parentNode.removeChild(existingEmpty);
    } else if (freshEmpty && !existingEmpty) {
      var drawerInner = drawer.querySelector('.drawer__inner');
      if (drawerInner) { drawerInner.insertBefore(freshEmpty.cloneNode(true), drawerInner.firstChild); }
    }

    var freshDI    = fresh.querySelector('cart-drawer-items');
    var existingDI = drawer.querySelector('cart-drawer-items');
    if (freshDI && existingDI) {
      existingDI.classList.toggle('is-empty', freshDI.classList.contains('is-empty'));
    }

    if (fresh.classList.contains('is-empty')) { drawer.classList.add('is-empty'); }
    else { drawer.classList.remove('is-empty'); }
  }

  /* ─────────────────────────────────────────
     HELPER: mmRefreshAndOpenDrawer
     ───────────────────────────────────────── */
  function mmRefreshAndOpenDrawer(trigger) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('cart-drawer');
          if (fresh) { mmApplyDrawerHTML(drawer, fresh); }
        }
        if (typeof drawer.open === 'function') drawer.open(trigger);
      })
      .catch(function () {
        if (typeof drawer.open === 'function') drawer.open(trigger);
      });
  }

  /* ─────────────────────────────────────────
     HELPER: mmRefreshDrawerSilently
     ── DEBUG VERSION ──
     ───────────────────────────────────────── */
  function mmRefreshDrawerSilently() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('cart-drawer');
        if (fresh) {
          mmApplyDrawerHTML(drawer, fresh);
          console.log('[mm-cart] drawer silently refreshed after cart page update');
        }
      })
      .catch(function (err) {
        console.log('[mm-cart] silent drawer refresh error:', err);
      });
  }

  /* ─────────────────────────────────────────
     6. PUBSUB (primary — çalışırsa en temiz)
     ───────────────────────────────────────── */
  if (typeof subscribe === 'function') {
    subscribe('cart-update', function (data) {
      var count =
        data && data.cartData && typeof data.cartData.item_count === 'number'
          ? data.cartData.item_count : null;

      if (count !== null) {
        console.log('[mm-cart] pubsub item_count:', count);
        var allBadges = document.querySelectorAll('.mm-nav-cart-badge');
        var allIcons  = document.querySelectorAll('.mm-nav-icon--cart');
        if (count > 0) {
          allBadges.forEach(function (b) { b.textContent = count; });
          allIcons.forEach(function (icon) {
            if (!icon.querySelector('.mm-nav-cart-badge')) {
              var badge = document.createElement('span');
              badge.className = 'mm-nav-cart-badge';
              badge.textContent = count;
              icon.appendChild(badge);
            }
          });
        } else {
          allBadges.forEach(function (b) { b.remove(); });
        }
      } else {
        scheduleFetch();
      }

      /* ── CART PAGE → DRAWER SYNC ──────────────────────────────
         cart-update'i drawer içi quantity değişimleri de publish
         eder. Sadece cart page kaynaklı event'lerde drawer'ı
         refresh etmemiz gerekiyor; drawer zaten kendi HTML'ini
         günceller.

         Tespit yöntemi: <cart-items> custom element'i yalnızca
         cart page'de bulunur (drawer <cart-drawer-items> kullanır).
         body class'ı theme'e göre değiştiğinden güvenilir değil.
      ────────────────────────────────────────────────────────── */
      if (document.querySelector('cart-items')) {
        mmRefreshDrawerSilently();
      }
    });
  }

})();